import { useAppSelector } from '../Redux/hooks';
import styles from './Card.module.scss';
import { ItemStatus, ItemType, Mode } from '../App';
import { Skeleton } from './Sceleton';
import { Discount } from './Discount';
import { useEffect, useState } from 'react';


type Props = {
  mode: Mode,
  item: ItemType,
  select: (id: string) => void,
  deleteItem: (id: string) => void,
  makeDiscount: (id: string, newPrice: number) => void,
}


export const Selectors: React.FC<Props> = ({ mode, item, select, deleteItem }) => {

  const isLogined = useAppSelector((state) => state.authorization.value);

  if (mode === Mode.CALCULATOR) {
    return <div className={styles.selectors}>
      <button className={styles.btn} onClick={() => deleteItem(item.article_id)}>
        <div>del</div>
      </button>
      <button className={styles.btn} onClick={() => select(item.article_id)}>
        {item.isSelected
          ? <div className={styles.yes}></div>
          : <div className={styles.no}></div>
        }
      </button>
    </div>
  } else if (mode === Mode.THE_OFFER && isLogined) {
    return <div className={styles.selectors}>
      <button className={styles.btn} onClick={() => deleteItem(item.article_id)}>
        <img src="assets/img/icons/cart.svg" alt="cart" />
      </button>
    </div>
  } else if (mode === Mode.THE_OFFER && !isLogined) {
    return <></>
  } else {
    return <></>
  }
}



export const Card: React.FC<Props> = ({ mode, item, select, deleteItem, makeDiscount }) => {

  const isLogined = useAppSelector((state) => state.authorization.value);

  const [discountHidden, setDiscountHidden] = useState(true);

  useEffect(() => {
    !isLogined && setDiscountHidden(true);
  }, [isLogined]);


  if (item.isLoading) { return <Skeleton article_id={item.article_id} /> }

  return (
    <article className={`${styles.Card} ${item.isSelected ? "" : styles.unselected} ${isLogined ? "" : styles.unLogined}`}>

      <Selectors mode={mode} item={item} select={select} deleteItem={deleteItem} makeDiscount={makeDiscount} />

      <div className={`${styles.imgBlock} ${!discountHidden ? styles.withDiscount : ''}`}>
        {item.status === ItemStatus.SOLD &&
          <span className={`${styles.itemStatus} ${styles.sold}`}>ПРОДАНО</span>
        }
        {item.status === ItemStatus.RESERVED &&
          <span className={`${styles.itemStatus} ${styles.reserved}`}>РЕЗЕРВ</span>
        }

        <a href={`https://bersoantik.com/ru/catalog/article/${item.article_id}/`} target="_blank" rel="noopener noreferrer">
          <img src={item.img_url} alt="Item" />
        </a>
      </div>

      {
        discountHidden
          ? <ul className={styles.itemParams}>
            <li>
              <a href={`https://bersoantik.com/ru/catalog/article/${item.article_id}/`} target="_blank" rel="noopener noreferrer">
                <h2>{item.title}</h2>
              </a>

            </li>

            <li>
              {(item.material[0] ? item.material[0].toUpperCase() + item.material.slice(1) : '')}
            </li>

            <li>
              {item.period}
            </li>

            <li className={styles.article_id}>
              арт. {item.article_id}
            </li>

            {item.status !== ItemStatus.SOLD &&
              <>
                <li>
                  {item.finalPrice !== item.startPrice &&
                    <del>{(item.startPrice).toLocaleString('ru')} руб.</del>
                  }
                  <b> {(item.finalPrice).toLocaleString('ru')} руб. </b>
                  {!!Math.round((1 - item.finalPrice / item.startPrice) * 100) &&
                    <> (-{Math.round((1 - item.finalPrice / item.startPrice) * 100)} %)</>
                  }
                </li>

                {isLogined &&
                  <li>
                    <button className={`${styles.btn} ${styles.percent}`} onClick={() => setDiscountHidden(false)}>-%</button>
                  </li>}
              </>
            }
          </ul>

          : <Discount
            id={item.article_id}
            hide={setDiscountHidden}
            startPrice={item.startPrice}
            finalPrice={item.finalPrice}
            makeDiscount={makeDiscount}
          />
      }
    </article >
  )
}